"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EActionsTypes;
(function (EActionsTypes) {
    EActionsTypes["init"] = "init";
    EActionsTypes["clear"] = "clear";
    EActionsTypes["set"] = "set";
    EActionsTypes["setErrors"] = "setErrors";
    EActionsTypes["add"] = "add";
    EActionsTypes["get"] = "get";
    EActionsTypes["update"] = "update";
    EActionsTypes["delete"] = "delete";
})(EActionsTypes = exports.EActionsTypes || (exports.EActionsTypes = {}));
//# sourceMappingURL=enums.js.map